export default "__VITE_ASSET__D5$cqKcR__"